export function transformTimeStringToDecimal(time: string, offset: number) {
  const [hoursStr, minutesStr] = time.split(':');
  const hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10);

  const value = hours + minutes / 60;

  return (value - offset + 24) % 24;
}
